namespace TabAurous {

    @Serenity.Decorators.registerClass([Serenity.ISetEditValue])
    @Serenity.Decorators.element("<div />")
    export class LabelEditor extends Serenity.Widget<LabelEditorOptions> {

        constructor(element: JQuery, opt?: LabelEditorOptions) {
            super(element, opt);

            var id = element.attr('id');
            if (Q.isTrimmedEmpty(id)) {
                element.attr('id', this.uniqueName);
                id = this.uniqueName;
            }

            if (!Q.isTrimmedEmpty(this.options.klass)) {
                element.addClass(this.options.klass);
            }
        }

        public setText(value: any) {
            this.element.text(value);
        }

        public setEditValue(source: any, property: Serenity.PropertyItem) {
            let propValue = source[property.name];
            this.element.text(propValue);
        }
    }

    export interface LabelEditorOptions {
        klass?: string;
    }


    @Serenity.Decorators.registerEditor()
    export class AmountEditor extends Serenity.DecimalEditor {

        constructor(input: JQuery, opt?: Serenity.DecimalEditorOptions) {
            super(input, opt);
            opt.decimals = 2;
            opt.allowNegatives = false;
            input.css('text-align', 'right');
        }
    }

    @Serenity.Decorators.registerEditor()
    export class PurityEditor extends Serenity.DecimalEditor {

        constructor(input: JQuery, opt?: Serenity.DecimalEditorOptions) {
            super(input, opt);
            opt.decimals = 4;
            opt.allowNegatives = false;
            opt.maxValue = "1";
            input.css('text-align', 'right');
        }
    }

    @Serenity.Decorators.registerEditor()
    export class PrcentageEditor extends Serenity.DecimalEditor {

        constructor(input: JQuery, opt?: Serenity.DecimalEditorOptions) {
            super(input, opt);
            opt.decimals = 2;
            opt.allowNegatives = false;
            input.css('text-align', 'right');
        }
    }


    @Serenity.Decorators.registerEditor()
    export class WeightEditor extends Serenity.DecimalEditor {

        constructor(input: JQuery, opt?: Serenity.DecimalEditorOptions) {
            super(input, opt);
            opt.decimals = 3;
            opt.allowNegatives = false;
            input.css('text-align', 'right');
        }
    }

    @Serenity.Decorators.registerEditor()
    export class PiecesEditor extends Serenity.IntegerEditor {

        constructor(input: JQuery, opt?: Serenity.IntegerEditorOptions) {
            super(input, opt);
            input.css('text-align', 'right');
        }
    }

    export interface ButtonEditorOptions {
        title?: string;
        emptyLabel?: boolean;
        cssClass?: string;
        primaryBtn?: boolean;
        successBtn?: boolean;
        warningBtn?: boolean;
        dangerBtn?: boolean;
    }

    @Serenity.Decorators.registerEditor('Button')
    @Serenity.Decorators.element("<button type='button'/>")
    export class ButtonEditor extends Serenity.Widget<ButtonEditorOptions> {
        public onClick: (eventObject: JQueryEventObject) => void;

        constructor(container: JQuery, options: ButtonEditorOptions) {
            super(container, options);

            if (this.options.emptyLabel)
                this.element.closest('.field').find('.caption').text('');;

            this.updateElementContent();
            this.element.click((e) => { this.onClick(e); })
        }

        private updateElementContent() {
            var classBtn = "btn ";

            if (Q.isEmptyOrNull(this.options.cssClass)) {
                if (this.options.primaryBtn)
                    classBtn += "btn-primary";
                else if (this.options.successBtn)
                    classBtn += "btn-success";
                else if (this.options.warningBtn)
                    classBtn += "btn-info";
                else if (this.options.dangerBtn)
                    classBtn += "btn-danger";
                else
                    classBtn += "btn-default";
            }
            else {
                classBtn = this.options.cssClass;
            }

            this.element.addClass(classBtn);
            this.element.html(this.options.title);
        }
    }
}